import { Transition } from "@headlessui/react";
import { XMarkIcon } from "@heroicons/react/20/solid";
import React, { Fragment, useEffect, useState } from "react";

import { useQueryParameter } from "../../hooks/use-query-parameter";

const PromoBanner = ({ shouldShow = true }) => {
  const [show, setShow] = useState(false);
  const query = useQueryParameter();

  useEffect(() => {
    const hasPromo = query.get("ref") === "producthunt";
    const hadPromo = localStorage.getItem("showProductHunt");

    if (hasPromo || hadPromo) {
      setShow(shouldShow);
      localStorage.setItem("showProductHunt", "true");
    }
  }, []);

  return (
    <>
      <div
        aria-live="assertive"
        className="pointer-events-none fixed inset-0 flex items-end px-4 py-6 sm:p-6"
        style={{ zIndex: 999 }}
      >
        <div className="flex w-full flex-col items-center space-y-4 sm:items-start">
          <Transition
            show={show}
            as={Fragment}
            enter="transform ease-out duration-300 transition"
            enterFrom="translate-y-2 opacity-0 sm:translate-y-0 sm:translate-x-2"
            enterTo="translate-y-0 opacity-100 sm:translate-x-0"
            leave="transition ease-in duration-100"
            leaveFrom="opacity-100"
            leaveTo="opacity-0"
          >
            <div
              className="pointer-events-auto w-full max-w-sm rounded-lg bg-white shadow-xl ring-1 ring-black ring-opacity-5"
              style={{ border: "1px solid #FF4500" }}
            >
              <div className="p-4">
                <div className="flex items-stretch">
                  <div className="flex h-100 items-center">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="60"
                      height="60"
                    >
                      <g fill="none">
                        <path
                          d="M58.48 29.24c0 16.148-13.092 29.24-29.24 29.24C13.09 58.48 0 45.388 0 29.24 0 13.09 13.091 0 29.24 0c16.148 0 29.24 13.091 29.24 29.24"
                          fill="#DA552F"
                        />
                        <path
                          d="M33.138 29.24h-8.284v-8.772h8.284a4.386 4.386 0 1 1 0 8.772m0-14.62H19.006v29.24h5.848v-8.772h8.284c5.652 0 10.234-4.582 10.234-10.234S38.79 14.62 33.138 14.62"
                          fill="#FFF"
                        />
                      </g>
                    </svg>
                  </div>
                  <div className="ml-5 w-0 flex-1 pt-0.5">
                    <p className="text-md font-medium text-slate-900">
                      Hey Product Hunt!
                    </p>
                    <p className="mt-1 text-sm text-slate-500">
                      For a limited time, get the full kit for <b>20% OFF</b>{" "}
                      the current price with code <b>HUNT20</b> at checkout!
                    </p>
                  </div>
                  <div className="ml-2 flex flex-shrink-0">
                    <button
                      type="button"
                      className="inline-flex rounded-md bg-white text-slate-400 hover:text-slate-500 focus:outline-none"
                      onClick={() => {
                        setShow(false);
                        localStorage.removeItem("showProductHunt");
                      }}
                    >
                      <span className="sr-only">Close</span>
                      <XMarkIcon className="h-5 w-5" aria-hidden="true" />
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </Transition>
        </div>
      </div>
    </>
  );
};

export default PromoBanner;
